import { __awaiter, __generator } from "tslib";
var AppSettingsClientAdapter = /** @class */ (function () {
    function AppSettingsClientAdapter(_a) {
        var appDefId = _a.appDefId, instanceId = _a.instanceId, externalId = _a.externalId;
        this.appDefId = appDefId;
        this.instanceId = instanceId;
        this.externalId = externalId;
    }
    AppSettingsClientAdapter.prototype.getAppDefId = function () {
        return this.appDefId;
    };
    AppSettingsClientAdapter.prototype.getInstanceId = function () {
        return this.instanceId;
    };
    AppSettingsClientAdapter.prototype.getExternalId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.externalId];
            });
        });
    };
    AppSettingsClientAdapter.prototype.setExternalId = function (id) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    AppSettingsClientAdapter.prototype.triggerSettingsUpdated = function (data, scope) { };
    AppSettingsClientAdapter.prototype.onSettingsUpdated = function (scope, cb) { };
    return AppSettingsClientAdapter;
}());
export { AppSettingsClientAdapter };
//# sourceMappingURL=AppSettingsClientAdapter.js.map